<template src="@/templates/reservations/insurances.html"></template>


<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      passengers: [],
      flights: [],
      selectedComponent: null,
      isLoading: true,
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getInsurances(this.reservationId, (data) => {
        this.passengers = data.insurances;
        this.isLoading = false;
      });
    },
    getRateIcon(rateType) {
      if (rateType === 'Percentage') {
        return '%';
      }
      return '€';
    },
    formatName(passenger) {
      return entityStore.formatPassengerName(passenger);
    },
    hasInsurances() {
      let hasInsurances = false;
      this.passengers.forEach((passenger) => {
        if (passenger.insurances.length > 0) {
          hasInsurances = true;
        }
      });
      return hasInsurances;
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// insurances.vue?b0b5ec6c